/* eslint-disable import/no-anonymous-default-export */
import express from '../images/icons/express.svg';
import postgres from '../images/icons/postgresql.svg';

export default [
    {
        id: 1,
        name: "HTML5",
        iconClassName: "fa-brands fa-html5",
        link: "https://developer.mozilla.org/en-US/docs/Web/HTML",
    },
    {
        id: 2,
        name: "CSS3",
        iconClassName: "fa-brands fa-css3-alt",
        link: "https://developer.mozilla.org/en-US/docs/Web/CSS",
    },
    {
        id: 3,
        name: "JAVASCRIPT",
        iconClassName: "fa-brands fa-js",
        link: "https://developer.mozilla.org/en-US/docs/Web/JavaScript",
    },
    {
        id: 4,
        name: "SASS",
        iconClassName: "fa-brands fa-sass",
        link: "https://sass-lang.com/",
    },
    {
        id: 5,
        name: "REACT",
        iconClassName: "fa-brands fa-react",
        link: "https://reactjs.org/",
    },
    {
        id: 6,
        name: "BOOTSTRAP",
        iconClassName: "fa-brands fa-bootstrap",
        link: "https://getbootstrap.com/",
    },
    {
        id: 7,
        name: "GITHUB",
        iconClassName: "fa-brands fa-github",
        link: "https://github.com/",
    },
    {
        id: 8,
        name: "NPM",
        iconClassName: "fa-brands fa-npm",
        link: "https://www.npmjs.com/",
    },
    {
        id: 9,
        name: "NodeJS",
        iconClassName: "fa-brands fa-node",
        link: "https://nodejs.org/en/",
    },
    {
        id: 10,
        name: "Express",
        iconSVG: express,
        link: "https://nodejs.org/en/",
    },
    {
        id: 11,
        name: "PostgreSQL",
        iconSVG: postgres,
        link: "https://nodejs.org/en/",
    },
]